import { render, staticRenderFns } from "./hello-world.vue?vue&type=template&id=3fb0075a&scoped=true"
import script from "./hello-world.vue?vue&type=script&lang=js"
export * from "./hello-world.vue?vue&type=script&lang=js"
import style0 from "./hello-world.vue?vue&type=style&index=0&id=3fb0075a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb0075a",
  null
  
)

export default component.exports